import React, { useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import swal from "sweetalert";
import {
  CRITERIO_AUSENCIA_DEMANDA_ID,
  esCriterioAusenciaDemanda,
  evaluacionEsAusenciaDemanda,
} from "../../utils/utils";

export const ModalCriteriosEvaluacionMonitoreo = (props) => {
  const toggle = () =>
    props.activarModalCriteriosEvaluacionMonitoreo(props.monitoreo);

  const { modalCriteriosEvaluacion } = props;

  const [evaluaciones, setEvaluaciones] = useState({});
  const [evaluacionesIds, setEvaluacionesIds] = useState({});
  const [botonesDeshabilitados, setBotonesDeshabilitados] = useState(false);
  const [datosCargados, setDatosCargados] = useState(false);

  useEffect(() => {
    if (modalCriteriosEvaluacion) {
      setEvaluaciones({});
      setEvaluacionesIds({});
      setBotonesDeshabilitados(false);
      setDatosCargados(false);
    }
  }, [props.monitoreo, modalCriteriosEvaluacion]);

  const seleccionar = (id, valor) => {
    if (botonesDeshabilitados) return;

    if (valor === "no_aplica") {
      if (evaluaciones[id] === "no_aplica") {
        setEvaluaciones((prev) => ({
          ...prev,
          [id]: "no_cumplio",
        }));
        return;
      }

      setEvaluaciones({ [id]: valor });
      return;
    }

    setEvaluaciones((prev) => ({
      ...prev,
      [id]: valor,
    }));
  };

  useEffect(() => {
    if (
      modalCriteriosEvaluacion &&
      props.modo === "editar" &&
      !datosCargados
    ) {
      const evaluacionesEditar = Array.isArray(props.evaluaciones)
        ? props.evaluaciones
        : [];

      if (evaluacionesEditar.length === 0) return;

      const evaluacionesMapeadas = {};
      const idsMapeados = {};

      const esAusenciaDemanda = evaluacionEsAusenciaDemanda(
        evaluacionesEditar,
        props.criterios
      );

      evaluacionesEditar.forEach((item) => {
        const criterio = props.criterios.find(
          (c) => c.criterioId === item.criterioId
        );

        idsMapeados[item.criterioId] = item.monitoreoEvaluacionId || 0;

        if (esAusenciaDemanda && !esCriterioAusenciaDemanda(criterio)) {
          return;
        }

        const valor = obtenerEstado(item, props.criterios, esAusenciaDemanda);

        evaluacionesMapeadas[item.criterioId] = valor;
      });

      setEvaluaciones(evaluacionesMapeadas);
      setEvaluacionesIds(idsMapeados);
      setDatosCargados(true);
    }
  }, [
    modalCriteriosEvaluacion,
    props.modo,
    props.evaluaciones,
    props.criterios,
    datosCargados,
  ]);

  const obtenerEstado = (item, criterios, esAusenciaDemanda = false) => {
    const criterio = criterios.find((c) => c.criterioId === item.criterioId);

    if (!criterio) return "no_cumplio";
    if (esAusenciaDemanda && esCriterioAusenciaDemanda(criterio)) {
      return "no_aplica";
    }

    if (item.resultado === 0) return "no_cumplio";
    if (item.resultado >= criterio.valorMaximo) return "cumplio";

    return "parcial";
  };

  const construirPayload = () => {
    const criterioAusenciaDemanda = props.criterios.find(
      esCriterioAusenciaDemanda
    );
    const ausenciaDemandaSeleccionada =
      criterioAusenciaDemanda &&
      evaluaciones[criterioAusenciaDemanda.criterioId] === "no_aplica";

    if (ausenciaDemandaSeleccionada) {
      return props.criterios.map((criterio) => ({
        monitoreoEvaluacionId: evaluacionesIds[criterio.criterioId] || 0,
        criterioId: criterio.criterioId,
        resultado: Number(criterio.criterioId) === CRITERIO_AUSENCIA_DEMANDA_ID
          ? "no_aplica"
          : "no_cumplio",
      }));
    }

    const payload = Object.keys(evaluaciones)
      .filter((criterioId) => {
        const criterio = props.criterios.find(
          (item) => item.criterioId === parseInt(criterioId)
        );

        return !esCriterioAusenciaDemanda(criterio);
      })
      .map((criterioId) => {
        const valor = evaluaciones[criterioId];

        return {
          monitoreoEvaluacionId: evaluacionesIds[criterioId] || 0,
          criterioId: parseInt(criterioId),
          resultado: valor,
        };
      });

    if (
      criterioAusenciaDemanda &&
      evaluacionesIds[criterioAusenciaDemanda.criterioId]
    ) {
      payload.push({
        monitoreoEvaluacionId:
          evaluacionesIds[criterioAusenciaDemanda.criterioId] || 0,
        criterioId: criterioAusenciaDemanda.criterioId,
        resultado: "no_cumplio",
      });
    }

    return payload;
  };

  const validarSeleccionCompleta = () => {
    const criterioAusenciaDemanda = props.criterios.find(
      esCriterioAusenciaDemanda
    );
    const ausenciaDemandaSeleccionada =
      criterioAusenciaDemanda &&
      evaluaciones[criterioAusenciaDemanda.criterioId] === "no_aplica";

    if (ausenciaDemandaSeleccionada) return true;

    const todosSeleccionados = props.criterios
      .filter((criterio) => !esCriterioAusenciaDemanda(criterio))
      .every((criterio) => evaluaciones[criterio.criterioId]);

    if (!todosSeleccionados) {
      swal(
        "Evaluacion incompleta",
        "Debe seleccionar una opcion para todos los criterios antes de guardar.",
        "warning"
      );
      return false;
    }

    return true;
  };

  const guardar = async () => {
    if (!validarSeleccionCompleta()) return;

    setBotonesDeshabilitados(true);
    try {
      await props.guardarEvaluacionMonitoreo(
        props.monitoreo.monitoreoId,
        evaluaciones
      );

      swal("Guardado", "La evaluacion se ha guardado correctamente.", "success").then(() => {
        toggle();
        setTimeout(() => {
          props.recargarLista();
        }, 1500);
      });
    } catch (error) {
      setBotonesDeshabilitados(false);
      swal("Error", "No se pudo guardar la evaluacion.", "error");
    }
  };

  const actualizar = async () => {
    if (!validarSeleccionCompleta()) return;

    const payload = construirPayload();

    setBotonesDeshabilitados(true);
    try {
      await props.actualizarEvaluacionMonitoreo(
        props.monitoreo.monitoreoId,
        payload
      );

      swal("Actualizado", "La evaluacion se ha actualizado correctamente.", "success").then(() => {
        toggle();
        setTimeout(() => {
          props.recargarLista();
        }, 1500);
      });
    } catch (error) {
      setBotonesDeshabilitados(false);
      swal("Error", "No se pudo actualizar la evaluacion.", "error");
    }
  };

  const criteriosOrdenados = useMemo(() => {
    return [...props.criterios].sort((a, b) => a.orden - b.orden);
  }, [props.criterios]);

  const criterioAusenciaDemandaSeleccionado = criteriosOrdenados.find(
    (criterio) =>
      esCriterioAusenciaDemanda(criterio) &&
      evaluaciones[criterio.criterioId] === "no_aplica"
  );

  return (
    <Modal
      isOpen={modalCriteriosEvaluacion}
      toggle={toggle}
      size="lg"
      backdrop="static"
    >
      <ModalHeader className="block-example border-bottom" toggle={toggle}>
        Criterios de evaluacion de la evidencia Devolucion - Monitoreo
      </ModalHeader>

      <ModalBody>
        <div className="list-group">
          {criteriosOrdenados.map((criterio) => {
            const esAusenciaDemanda = esCriterioAusenciaDemanda(criterio);
            const criterioDeshabilitado =
              !esAusenciaDemanda &&
              Boolean(criterioAusenciaDemandaSeleccionado);

            return (
              <div key={criterio.criterioId} className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-md-7">
                    <p className="mb-0">{criterio.descripcion}</p>
                  </div>
                  <div className="col-md-5 text-end border-left">
                    <div className="btn-group">
                      {esAusenciaDemanda ? (
                        <button
                          className={`btn btn-sm btn-na ${evaluaciones[criterio.criterioId] === "no_aplica"
                              ? "btn-na-active"
                              : ""
                            }`}
                          onClick={() =>
                            seleccionar(criterio.criterioId, "no_aplica")
                          }
                          disabled={botonesDeshabilitados}
                        >
                          N/A
                        </button>
                      ) : (
                        <React.Fragment>
                          <button
                            className={`btn btn-sm ${evaluaciones[criterio.criterioId] === "cumplio"
                                ? "btn-success"
                                : "btn-outline-success"
                              }`}
                            onClick={() =>
                              seleccionar(criterio.criterioId, "cumplio")
                            }
                            disabled={botonesDeshabilitados || criterioDeshabilitado}
                          >
                            Cumplio
                          </button>

                          <button
                            className={`btn btn-sm ${evaluaciones[criterio.criterioId] === "parcial"
                                ? "btn-warning"
                                : "btn-outline-warning"
                              }`}
                            onClick={() =>
                              seleccionar(criterio.criterioId, "parcial")
                            }
                            disabled={botonesDeshabilitados || criterioDeshabilitado}
                          >
                            Parcialmente
                          </button>

                          <button
                            className={`btn btn-sm ${evaluaciones[criterio.criterioId] === "no_cumplio"
                                ? "btn-danger"
                                : "btn-outline-danger"
                              }`}
                            onClick={() =>
                              seleccionar(criterio.criterioId, "no_cumplio")
                            }
                            disabled={botonesDeshabilitados || criterioDeshabilitado}
                          >
                            No cumplio
                          </button>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </ModalBody>

      <ModalFooter>
        <button
          className="btn btn-danger btn-sm"
          onClick={(e) => {
            e.preventDefault();
            props.modo === "editar" ? actualizar() : guardar();
          }}
          disabled={botonesDeshabilitados}
        >
          {props.modo === "editar" ? "Actualizar" : "Guardar"}
        </button>

        <button
          className="btn btn-info btn-sm"
          onClick={(e) => {
            e.preventDefault();
            toggle();
          }}
        >
          Cancelar
        </button>
      </ModalFooter>
    </Modal>
  );
};
